// extracted by mini-css-extract-plugin
export var colorSquare = "_tz-0";
export var danger = "_tz-5";
export var lightPink = "_tz-8";
export var neutralBlue = "_tz-7";
export var neutralYellow = "_tz-6";
export var normal = "_tz-1";
export var primary = "_tz-2";
export var primaryLight = "_tz-3";
export var solidBlack = "_tz-g";
export var solidGreen = "_tz-b";
export var solidLightBlue = "_tz-d";
export var solidNavy = "_tz-c";
export var solidOrange = "_tz-f";
export var solidPink = "_tz-e";
export var solidRed = "_tz-9";
export var solidYellow = "_tz-a";
export var success = "_tz-4";